var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewsletter = function SvgNewsletter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE575",
    d: "m494 169-46-37v41l26 21c4 3 6 8 6 12v258c0 9-7 16-16 16H48c-9 0-16-7-16-16V206c0-5 2-9 6-12l26-21v-41l-46 37c-11 9-18 23-18 37v258c0 27 22 48 48 48h416c27 0 48-21 48-48V206c0-14-6-28-18-37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE575",
    d: "M400 50H112c-26 0-48 21-48 48v157c4-3 10-3 15 1l17 14V98c0-9 7-16 16-16h288c9 0 16 7 16 16v172l17-14c5-4 11-4 15-1V98c0-27-21-48-48-48zM256 32c12 0 26 8 40 18h50c-21-18-55-50-90-50s-68 32-90 50h50c14-10 28-18 40-18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE575",
    d: "M455 264c4 5 4 12-2 17l-104 83c-21 16-57 52-93 52-37 0-73-36-93-52L58 281c-5-5-6-12-1-17l5-7c4-5 11-5 16-1l104 83c17 13 51 45 74 45s56-32 73-45l104-83c5-5 13-4 17 1l5 7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE575",
    d: "M160 270v-8c0-7 5-12 12-12h168c7 0 12 5 12 12v8c0 6-5 12-12 12H172c-7 0-12-5-12-12zM160 206v-8c0-7 5-12 12-12h168c7 0 12 5 12 12v8c0 7-5 12-12 12H172c-7 0-12-5-12-12zM160 142v-8c0-7 5-12 12-12h168c7 0 12 5 12 12v8c0 7-5 12-12 12H172c-7 0-12-5-12-12z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewsletter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newsletter.56dfced1.svg";
export { ForwardRef as ReactComponent };